import { render } from "./AddPassengerModalView.vue?vue&type=template&id=04c4e04a&scoped=true"
import script from "./AddPassengerModalView.vue?vue&type=script&lang=js"
export * from "./AddPassengerModalView.vue?vue&type=script&lang=js"

import "./AddPassengerModalView.vue?vue&type=style&index=0&id=04c4e04a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c4e04a"]])

export default __exports__